import React, { useState, useEffect } from 'react';
import { Map as AzureMap, control } from 'azure-maps-control';
import styled from 'styled-components';
import {
  AZURE_MAP_KEY,
  DEFAULT_LAT,
  DEFAULT_LON,
  drawHtmlMarkers,
} from '../../utils/geoLocation';

const Wrapper = styled.div`
  height: 600px;
  z-index: 10;

  @media (max-height: 900px) {
    height: 400px;
  }
`;

export default function Map(props) {
  const elId = props.elId !== undefined ? props.edId : 'AzureMapContainerId';

  const [mapObject, setMapObject] = useState(null);

  // Initialize Map
  useEffect(() => {
    const map = new AzureMap(elId, {
      center: [
        props.longitude !== undefined ? props.longitude : DEFAULT_LON,
        props.latitude !== undefined ? props.latitude : DEFAULT_LAT,
      ],
      zoom: props.zoom !== undefined ? props.zoom : 4,
      language: props.language !== undefined ? props.language : 'en-Us',
      style: props.style !== undefined ? props.style : 'road',
      authOptions: {
        authType: 'subscriptionKey',
        subscriptionKey:
          props.subscriptionKey !== undefined
            ? props.subscriptionKey
            : AZURE_MAP_KEY,
      },
    });

    map.events.add('ready', () => {
      const controlPosition =
        props.controlPosition !== undefined
          ? props.controlPosition
          : 'top-left';
      if (props.zoomControls !== false) {
        map.controls.add(new control.ZoomControl(), {
          position: controlPosition,
        });
      }
      if (props.pitchControls !== false) {
        map.controls.add(new control.PitchControl(), {
          position: controlPosition,
        });
      }
      if (props.compassControls !== false) {
        map.controls.add(new control.CompassControl(), {
          position: controlPosition,
        });
      }
      setMapObject(map);
    });
    // eslint-disable-next-line
  }, []);

  // Draw Html Markers when markers change or MapObject state changes to something else than null
  useEffect(() => {
    if (mapObject !== null && props.htmlMarkers.length > 0) {
      drawHtmlMarkers(props.htmlMarkers, mapObject);
    }
  }, [props.htmlMarkers, mapObject]);

  useEffect(() => {
    if (mapObject) {
      mapObject.setCamera({
        center: [props.longitude, props.latitude],
      });
    }
  }, [mapObject, props.latitude, props.longitude, props.zoom]);

  return <Wrapper id={elId} />;
}
